/**
 * Strip trailing slash from a path if it exists
 *
 * @example
 * stripTrailingSlash('/a/b/c/') -> '/a/b/c'
 * stripTrailingSlash('/') -> '/'
 */
export default function stripTrailingSlash(path: string): string {
  return path.endsWith('/') && path !== '/' ? path.substring(0, path.length - 1) : path;
}
